import { FC } from 'react';
import { Detalle } from '@/types/dashboard/RoRoPage';
import { useTranslation } from 'react-i18next';

import { Table } from '@/components';
import { getTableColumns } from './getTableColumns';
import { tableFilters } from './tableFilters';
import styles from './DetallesTable.module.scss';

// Define the type for DetalleOmit, converting date fields to strings
export type DetalleOmit = Omit<Detalle, 'fechaRegistro' | 'fechaDescarga'> & {
  fechaRegistro: string;
  fechaDescarga: string;
};

type DetallesTableProps = {
  data: DetalleOmit[] | undefined;
  isLoading?: boolean;
};

const DetallesTable: FC<DetallesTableProps> = ({ data, isLoading }) => {
  const tableColumns = getTableColumns();
  const { t } = useTranslation('dashboardPage');

  return (
    <>
      <h2 className={styles.title}>{t('roRoPage.detalle')}</h2>
      <Table
        columns={tableColumns}
        data={data}
        isLoading={isLoading}
        filters={tableFilters}
        paginator
        filterDisplay="menu"
      />
    </>
  );
};

export default DetallesTable;
